import { render, staticRenderFns } from "./promoteFrom.vue?vue&type=template&id=1e30effa&scoped=true"
import script from "./promoteFrom.vue?vue&type=script&lang=js"
export * from "./promoteFrom.vue?vue&type=script&lang=js"
import style0 from "./promoteFrom.vue?vue&type=style&index=0&id=1e30effa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e30effa",
  null
  
)

export default component.exports